import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams }from 'react-router-dom';
import { Form, Button} from 'react-bootstrap';
import FormContainer from '../../components/FormContainer';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { useUpdateProductMutation, useGetProductDetailsQuery, useUploadProductImageMutation } from '../../slices/productsApiSlice';

const ProductEditScreen = () => {
  const { id: productId } = useParams();

  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState("");
  const [brand, setBrand] = useState("");
  const [category, setCategory] = useState("");
  const [countInStock, setCountInStock] = useState(0);
  const [description, setDescription] = useState("");

  const { data: product, isLoading, error } = useGetProductDetailsQuery(productId);

  const [updateProduct, { isLoading: loadingUpdate }] = useUpdateProductMutation();

  const [uploadProductImage, { isLoading: loadingUpload }] = useUploadProductImageMutation();

  const navigate = useNavigate();

  useEffect(() => { 
    if (product) {
      setName(product.name);
      setPrice(product.price);
      setImage(product.image);
      setBrand(product.brand);
      setCategory(product.category);
      setCountInStock(product.countInStock);
      setDescription(product.description);
    }
  }, [product]);

  const submitHandler = async (e) => {
    e.preventDefault();
    const updatedProduct = {
      productId,
      name,
      price,
      image,
      brand,
      category,
      countInStock,
      description,
    };

    const result = await updateProduct(updatedProduct);
    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("商品已更新");
      navigate("/admin/productlist");
    }
  }

  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    try {
      const res = await uploadProductImage(formData).unwrap();
      toast.success(res.message);
      setImage(res.image);
    } catch(err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return <>
    <Link to="/admin/productlist" className="btn btn-light my-3">
    返回
    </Link>
    <FormContainer>
      <h1>編輯商品</h1>
      {loadingUpdate && <Loader />}

      {isLoading ? <Loader /> : error ? <Message variant="danger">{error.data.message}</Message> : (
        <Form onSubmit= { submitHandler }>
          <Form.Group controlId="name" className="my-2">
            <Form.Label>商品名稱</Form.Label>
            <Form.Control
             type="text"
             placeholder="請輸入商品名稱"
             value={name}
             onChange={(e) => setName(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
      
          <Form.Group controlId="price" className="my-2">
            <Form.Label>價格</Form.Label>
            <Form.Control
             type="number"
             placeholder="請輸入價格"
             value={price}
             onChange={(e) => setPrice(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
          
          <Form.Group controlId="image" className="my-2">
            <Form.Label>商品圖片</Form.Label>
            <Form.Control 
            type="next" 
            placeholder="請輸入圖片網址" 
            value={image} 
            onChange={(e) => setImage}
            >
            </Form.Control>
            <Form.Control 
              type="file" 
              label="選擇檔案" 
              onChange={uploadFileHandler}
            >
            </Form.Control>
          </Form.Group>
          {loadingUpload && <Loader />}

          <Form.Group controlId="brand" className="my-2">
            <Form.Label>品牌</Form.Label>
            <Form.Control
             type="text"
             placeholder="請輸入品牌"
             value={brand}
             onChange={(e) => setBrand(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="countInStock" className="my-2">
            <Form.Label>庫存數量</Form.Label>
            <Form.Control
             type="number"
             placeholder="請輸入庫存數量"
             value={countInStock}
             onChange={(e) => setCountInStock(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="category" className="my-2">
            <Form.Label>分類</Form.Label>
            <Form.Control
             type="text"
             placeholder="請輸入分類"
             value={category}
             onChange={(e) => setCategory(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="description" className="my-2">
            <Form.Label>商品描述</Form.Label>
            <Form.Control
             type="text"
             placeholder="請輸入商品描述"
             value={description}
             onChange={(e) => setDescription(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="my-2"
          >
            更新
          </Button>
        </Form>
      )}
    </FormContainer>
  </>
}

export default ProductEditScreen;